import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ManagedAccount } from '@webdev/user-management';
import { useAlerts } from '../../feedback';
import { getManagedAccountsQueryKey } from './useGetManagedUsers';
import { useUserManagementClientContext } from './UserManagementClientContext';

export const useRemoveManagedUser = () => {
  const client = useUserManagementClientContext();
  const queryClient = useQueryClient();
  const { showError, showSuccess } = useAlerts();

  const { mutate } = useMutation({
    mutationFn: (user: Pick<ManagedAccount, 'id' | 'email'>) => {
      return client.removeManagedUsers([user.id]);
    },
    onSuccess: (_, user) => {
      queryClient.invalidateQueries({ queryKey: getManagedAccountsQueryKey });
      showSuccess(`User ${user.email} was removed`);
    },
    onError: (error, user) => {
      showError(`User ${user.email} could not be removed`);
    },
  });

  return { removeManagedUser: mutate };
};
